export const emailType = [
  { id: "Invoice", name: "Invoice", color: "#00bcd4" },
  { id: "CreditNote", name: "Credit Note", color: "#7c4dff" },
  { id: "CustomerReceipt", name: "Customer Receipt", color: "#7c4dff" },
  { id: "ResetPassword", name: "Reset Password", color: "#ff9800" },
  { id: "StudentRenewal", name: "Student Renewal", color: "#285F96" },
  { id: "RegisterStudent", name: "Register Student", color: "#543F96" },
  { id: "PaymentReminder", name: "Payment Reminder", color: "#809900" },
];

export const statusList = [
  { id: "Success", name: "Success" },
  { id: "Failed", name: "Failed" },
];
